import createGetFormSubmitErrors from './selectors/getFormSubmitErrors';
import plain from './structure/plain';

export default createGetFormSubmitErrors(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormSubmitErrors.js
// module id = 4267
// module chunks = 25